import * as React from "react";
import { cloneDeep } from "lodash";
import { FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { AccessReportsWizardProduct } from "@app/access-reports/shared/accessReportsWizardProduct";

interface AccessReportsAdminAddProductAddSpecialtiesProps {
  hideSidePanel: () => void;
  onAddSpecialtiesClick: (specialties: string[]) => void;
  product: AccessReportsWizardProduct;
}

const AccessReportsAdminAddProductAddSpecialties: React.FC<AccessReportsAdminAddProductAddSpecialtiesProps> = (props: AccessReportsAdminAddProductAddSpecialtiesProps) => {
  const [specialties, setSpecialties] = React.useState<string[]>([]);
  const [specialty, setSpecialty] = React.useState("");

  const getAddSpecialtyButtonValidity = (): boolean => {
    const savedAccessCriterionNames: string[] = props.product.accessCriterion.map(x => x.name);
    const upcomingAccessCriterionNames: string[] = cloneDeep(specialties);
    const allAccessCriterionNames: string[] = savedAccessCriterionNames.concat(upcomingAccessCriterionNames);

    if (!!specialty &&
      !allAccessCriterionNames.includes(specialty)
    ) {
      return true;
    }
  }

  const getAddSpecialtyValidationText = (): string => {
    const savedAccessCriterionNames: string[] = props.product.accessCriterion.map(x => x.name);
    const upcomingAccessCriterionNames: string[] = cloneDeep(specialties);
    const allAccessCriterionNames: string[] = savedAccessCriterionNames.concat(upcomingAccessCriterionNames);

    if (allAccessCriterionNames.includes(specialty)) {
      return "A specialty with that name already exists";
    }
  }

  const onAddSpecialtiesClick = (): void => {
    props.onAddSpecialtiesClick(specialties);

    setSpecialties([]);
  }

  const onAddSpecialtyClick = (): void => {
    const newSpecialties: string[] = cloneDeep(specialties);
    newSpecialties.push(specialty);

    setSpecialties(newSpecialties);
    setSpecialty("");
  }

  const onRemoveSpecialtyClick = (specialty: string): void => {
    const specialtiesClone: string[] = cloneDeep(specialties);
    const newSpecialties: string[] = specialtiesClone.filter(x => x !== specialty);

    setSpecialties(newSpecialties);
  }

  const onSpecialtyInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSpecialty(event.target.value);
  }

  const addSpecialtyValidationText: string = getAddSpecialtyValidationText();

  return (
    <React.Fragment>
      <div>
        <div className="row">
          <div className="col-12">
            <QESTextInput
              inputAppend={(
                <QESButton
                  qesType="secondary"
                  className="p-1"
                  disabled={!getAddSpecialtyButtonValidity()}
                  qesTestId="access-reports-admin__add-specialties--input-add"
                  onClick={() => onAddSpecialtyClick()}
                >
                  Add
                </QESButton>
              )}
              testId="access-reports-admin__add-specialties--input"
              errorText={addSpecialtyValidationText}
              isValid={!addSpecialtyValidationText}
              label="Specialty"
              onChange={(e) => onSpecialtyInputChange(e)}
              unrequiredValidation={true}
              value={specialty}
            />

            {specialties.length > 0 &&
              <React.Fragment>
                <hr />

                {specialties.map((specialty, index) => (
                  <QESTextInput
                    inputAppend={(
                      <QESButton
                        className="p-1"
                        qesTestId={`access-reports-admin__add-specialties--remove-${index}`}
                        qesType="secondary-danger"
                        onClick={() => onRemoveSpecialtyClick(specialty)}
                      >
                        Remove
                      </QESButton>
                    )}
                    key={index}
                    readOnly
                    testId={`access-reports-admin__add-specialties--readonly-${index}`}
                    label={specialty}
                    hideLabel={true}
                    value={specialty}
                  />
                ))}
              </React.Fragment>
            }
          </div>
        </div>
      </div>

      <FlyoutFooter
        submitButton={
          <QESButton
            className="ms-3"
            disabled={specialties.length < 1}
            onClick={() => onAddSpecialtiesClick()}
            qesTestId="access-reports-admin__add-specialties--add"
            qesType="primary"
          >
            Add
          </QESButton>
        }
      />
    </React.Fragment>
  );
}

export { AccessReportsAdminAddProductAddSpecialties };
